import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import {
  OFFICIAL_TOURNAMENTS_PATH,
  tournamentStaffHomePath,
  tournamentStaffPathAllowed,
} from '../../../contexts/tournamentManagers';

/** Vrai pour les seules pages d'un staff de tournoi officiel : `/app/tournois-officiels` et `/app/tournois-officiels/:id`. */
export function isTournamentStaffPath(pathname) {
  const path = String(pathname || '').replace(/\/+$/, '');
  if (path === OFFICIAL_TOURNAMENTS_PATH) return true;
  if (!path.startsWith(`${OFFICIAL_TOURNAMENTS_PATH}/`)) return false;
  const rest = path.slice(OFFICIAL_TOURNAMENTS_PATH.length + 1);
  return Boolean(rest) && !rest.includes('/');
}

/**
 * Garde de route de l'ERP (docs/OFFICIAL_TOURNAMENTS.md § 4.3, docs/TOURNAMENT_MANAGERS.md) : un staff de tournoi (sans
 * rôle d'admin dans le club) n'atteint que « Mes tournois officiels » et la fiche d'un tournoi officiel, plus, s'il gère
 * des tournois du club, l'écran Matchs, le bracket et la fiche de SES tournois ; toute autre page `/app/*` le renvoie à son
 * accueil. Les autres rôles passent. Garde d'interface seulement : l'API fait foi. Avec `children`, les rend ; sinon
 * (route parente) rend les routes enfants avec le contexte de l'ErpShell.
 */
export default function RequireTournamentStaff({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const shellContext = useOutletContext();
  if (user?.role === 'tournament_staff' && !tournamentStaffPathAllowed(pathname, user)) {
    return <Navigate to={tournamentStaffHomePath(user)} replace />;
  }
  return children ?? <Outlet context={shellContext} />;
}
